import React from 'react'

import { Dropdown } from '@sketch/components'
import {
  ProjectListItemFragment,
  WorkspaceMinimalFragment,
} from '@sketch/gql-types'

import {
  CopyProjectAction,
  LeaveProjectAction,
  RestoreProjectAction,
  DeleteProjectPermanentlyAction,
} from '../ProjectDropdownActions'

export interface ProjectTrashedDropdownProps {
  workspace: Pick<WorkspaceMinimalFragment, 'identifier' | 'userCanAdminister'>
  project: Pick<
    ProjectListItemFragment,
    | '__typename'
    | 'identifier'
    | 'name'
    | 'userCanLeave'
    | 'deletedAt'
    | 'parentProjectIdentifier'
  >
}

export const ProjectTrashedDropdown: React.FC<
  ProjectTrashedDropdownProps
> = props => {
  const { workspace, project } = props
  const workspaceId = workspace.identifier

  const showLeaveProjectAction = project.userCanLeave
  const showDeletePermanentlyAction = workspace.userCanAdminister

  return (
    <>
      <CopyProjectAction project={project} workspaceId={workspaceId} />
      <Dropdown.Divider />
      <RestoreProjectAction project={project} workspaceId={workspaceId} />

      {(showLeaveProjectAction || showDeletePermanentlyAction) && (
        <Dropdown.Divider />
      )}

      {showLeaveProjectAction && (
        <LeaveProjectAction
          workspaceIdentifier={workspaceId}
          projectIdentifier={project.identifier}
          projectName={project.name}
        />
      )}
      {showDeletePermanentlyAction && (
        <DeleteProjectPermanentlyAction
          project={project}
          workspaceId={workspaceId}
        />
      )}
    </>
  )
}
